import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import Sidebar from "../components/sidebar/sidebar";
import Navbar from "../components/navbar/navbar";

const PrivateRoute = () => {
  return localStorage.getItem("accessToken") ? (
    <main className="h-full w-full p-2">
      <Navbar />
      <div className="flex gap-2 py-2 h-[calc(100vh-4.5rem)]">
        <div className="w-[20vw] max-w-[14vw] items-center">
          <Sidebar />
        </div>
        <div className="w-full h-full">
          <Outlet />
        </div>
      </div>
    </main>
  ) : (
    <Navigate to="/" />
  );
};

export default PrivateRoute;
